import { phoneApi } from '@alfa-bank/newclick-api/phone-api';
export const apiMethods = {
    getPhoneInformationApiMethod: phoneApi.getPhoneInformation,
};
